import { styled } from "@mui/material";

const ToolStyled = styled("div")(({ theme }) => ({
  position: "absolute",
  zIndex: theme.zIndex.max,
}));

const MapToolPositionUnstyled = ({ className, children }) => {
  return <ToolStyled className={className}>{children}</ToolStyled>;
};
const MapToolPosition = styled(MapToolPositionUnstyled)({});
export default MapToolPosition;
